import template from "./textarea.html";
import {
	EVENT_CLEAR_VALUE,
	EVENT_REVERT_VALUES,
	EVENT_PAGE_LOADED,
	EVENT_SET_FORM_PRISTINE
} from "constants.js";
import { find } from "lodash";
import "./textarea.less";

// text
export class Controller {
	constructor($scope) {
		this._scope = $scope;
	}

	$onInit() {
		this._eventBus = this.reportScope.events;
		this._unregister = this.reportFormCtrl.registerFieldController(this);

		this.initialValue = find(this.values, v => v.FieldId === this.field.Id);
		this.setValue();

		this._eventBus.register(EVENT_CLEAR_VALUE(this.field.Id), () => {
			this.value = null;
		}, this._scope);

		this._eventBus.register(EVENT_REVERT_VALUES, () => {
			this.revertValue();
		}, this._scope);

		this._eventBus.register(EVENT_PAGE_LOADED, () => {
			this.autoExpand(document.getElementById("REPORT.FEEDBACK"));
		}, this._scope);

		this._eventBus.register(EVENT_SET_FORM_PRISTINE, () => {
			this.setPristine();
		}, this._scope);

		document.addEventListener("input", event => {
			if(event.target.tagName.toLowerCase() !== "textarea") {
				return;
			}
			this.autoExpand(event.target);
		}, false);
	}

	$onDestroy() {
		this._unregister();
	}

	getCurrentValue(isApiCall) {
		const result = this.buildResult();

		if(result && !isApiCall && this.field.IsNotReported !== true && this.field.IsHidden !== true) {
			result.IsDirty = this.value !== (this.initialValue && this.initialValue.String);
		}

		return result ? [result] : [];
	}

	revertValue() {
	}

	checkForDirty() {
		const isDirty = (this.field.visible !== false || this.initialValue !== undefined) && (this.value !== this.initialValue?.String);
		this.setFieldDirty(this.field.Id, isDirty);
	}

	handleInput() {
		const content = this.value;
		if((/^[ -~]*$/.test(content))) { //regex matches all ASCII characters except for backspace
		} else {
			this.value = content.replace(/[^ -~]/g, ""); //regex replaces characters that are not ASCII - backspace with an empty string
		}
	}

	setPristine() {
		this.initialValue = this.field.IsDetail ? undefined : this.buildResult();
	}

	buildResult() {
		return this.value ? {
			FieldId: this.field.Id,
			String: this.value
		} : undefined;
	}

	setValue(val) {
		if(val) {
			this.value = val;
			return;
		}

		const value = find(this.values, v => v.FieldId === this.field.Id);

		if(value) {
			this.value = value.String;
		}
	}

	getValidationStyling() {
		return this.field.hasValidationError ? "validation-error"
			: this.field.hasValidationWarning ? "validation-warning" : "";
	}

	autoExpand(field) {
		field.style.height = "inherit";

		const computed = window.getComputedStyle(field);

		const height = parseInt(computed.getPropertyValue("border-top-width"), 10)
			+ parseInt(computed.getPropertyValue("padding-top"), 10)
			+ field.scrollHeight
			+ parseInt(computed.getPropertyValue("padding-bottom"), 10)
			+ parseInt(computed.getPropertyValue("border-bottom-width"), 10);

		field.style.height = height + "px";
	}
}

export default angular
	.module("vesl.components.report-form.text-area", [])
	.component("textArea", {
		template,
		controller: Controller,
		bindings: {
			field: "<",
			values: "<",
			setFieldDirty: "="
		},
		require: {
			reportFormCtrl: "^reportForm",
			reportScope: "^^reportScope"
		}
	}).name;
